import React, { Component } from "react";
import SectionFooter from "./sectionfooter";

class Kontact extends Component {
  render() {
    return (
      <section id="contact">
        <h1>Der Vorstand</h1>
        <div className="primary">
          <ul className="folio-list clearfix">
            <li className="folio-thumb contact-left">
              <h5>
                Erster Vorsitzender,
                <br /> Tambourmajor
              </h5>
              <br />
              Karl-Peter Klee<br />
              Sonnenweg 5<br />
              51789 Lindlar<br />
              Telefon: 02266 / 1605<br />
              E-Mail: &nbsp;
              <a href="mailto:&#107;&#097;&#108;&#108;&#101;&#107;&#108;&#101;&#101;&#064;&#103;&#109;&#120;&#046;&#100;&#101;">
                &#107;&#097;&#108;&#108;&#101;&#107;&#108;&#101;&#101;&#064;&#103;&#109;&#120;&#046;&#100;&#101;
              </a>
              <br />
            </li>
            <li className="folio-thumb contact-right">
              <h5>Zweiter Vorsitzender</h5>
              <br />
              <br />
              Willi Schmitz<br />
              Schlüsselberg 38<br />
              51789 Lindlar<br />
              Telefon: 02266 / 8175<br />
              E-Mail: &nbsp;
              <a href="mailto:&#098;&#119;&#046;&#115;&#099;&#104;&#108;&#117;&#101;&#115;&#115;&#101;&#108;&#098;&#101;&#114;&#103;&#064;&#103;&#109;&#120;&#046;&#100;&#101;">
                &#098;&#119;&#046;&#115;&#099;&#104;&#108;&#117;&#101;&#115;&#115;&#101;&#108;&#098;&#101;&#114;&#103;&#064;&#103;&#109;&#120;&#046;&#100;&#101;
              </a>
              <br />
            </li>
          </ul>
        </div>
        <SectionFooter />
      </section>
    );
  }
}

export default Kontact;



// WEBPACK FOOTER //
// ./src/components/kontakt.js